// en, de, fr, pt
export default {
  si: {
    //user
    UserList: 'Uporabniki',
    UserAdd: 'Dodaj uporabnika',
    AddUser: 'Dodaj uporabnika',
    Email: 'E-pošta',
    Username: 'Uporabniško ime',
    Password: 'Geslo',
    RepeatPassword: 'Ponovi geslo',
    BackToUsersButton: 'Nazaj na uporabnike',
    UserSuccessfullyRemoved: 'Uporabnik uspešno odstranjen!',
    DeleteUserAlert: 'Ali ste prepričani, da želite odstraniti uporabnika?',

    //report
    AddReport: 'Dodaj poročilo',
    ReportsList: 'Poročila',
    Filename: 'Ime datoteke',
    Datetime: 'Datum in čas',
    Reports: 'Poročila',
    ReportData: 'Podatki o poročilu',
    NoReportsFound: 'Ni bilo najdenih poročil.',
    AddDailyReport: 'Dodaj dnevno poročilo',
    DailyReport: 'Dnevno poročilo',
    EditDailyReport: 'Uredi dnevno poročilo',
    DailyReportList: 'Seznam dnevnih poročil',
    AddDailyCashierReport: 'Dodaj dnevno poročilo blagajne',
    DailyCashierReport: 'Dnevno poročilo blagajne',
    EditDailyCashierReport: 'Uredi dnevno poročilo blagajne',
    DailyCashierReportList: 'Seznam dnevnih poročil blagajne',
    AddWorkHourDiary: 'Dodaj dnevnik delovnih ur',
    WorkHourDiary: 'Dnevnik delovnih ur',
    EditWorkHourDiary: 'Uredi dnevnih delovnih ur',
    WorkHourDiaryList: 'Seznam dnevnikov delovnih ur',
    AddAutomaticCashRegisterReport: 'Dodaj poročilo avtomatske blagajne',
    AutomaticCashRegisterReport: 'Poročilo avtomatske blagajne',
    EditAutomaticCashRegisterReport: 'Uredi poročilo avtomatske blagajne',
    AutomaticCashRegisterReportList: 'Seznam poročil avtomatske blagajne',
    Report: 'Poročilo',
    Export: 'Izvozi',
    Cash: 'Gotovina',
    Pos: 'POS',
    TransferTRR: 'Nakalizo na TRR',
    Coins: 'Kovanci',
    CoinsTotal: 'Obračun - kovanci',
    Banknotes: 'Bankovci',
    BanknotesTotal: 'Obračun - bankovci',
    CoinsBanknotesTotal: 'Obračun - skupaj',
    Important: 'Pomembno',
    GeneratePdf: 'Generiraj PDF',


    //shift
    Shift: 'Izmena',
    Shifts: 'Izmene',
    AddShift: 'Dodaj izmeno',
    ShiftAdd: 'Dodaj izmeno',
    NoShiftsFound: 'Ni bilo najdenih izmen.',
    ShiftsList: 'Izmene',
    ShiftData: 'Podatki o izmeni',
    EditShift: 'Uredi izmeno',
    DeleteShiftAlert: 'Ali ste prepričani, da želite odstraniti izmeno?',
    TimeFrom: 'Čas od',
    TimeTo: 'Čas do',
    AddWorkHours: 'Dodaj ure',
    EditWorkHours: 'Uredi delovne ure',
    WorkHours: 'Oddelane ure',
    NoWorkHoursFound: 'Ure niso vnešene',
    ExtraHours: 'Dodatne ure',
    Explanation: 'Obrazložitev',
    SearchWorkHours: 'Oddelane ure v izbranem obdobju',

    //Monthly working hours
    MonthlyWorkingHours: 'Mesečne opravljene delovne ure',
    AddMonthlyWorkingHours: 'Dodaj mesečne opravljene delovne ure',
    EditMonthlyWorkingHours: 'Uredi mesečne opravljene delovne ure',
    NoMonthlyWorkingHoursFound: 'Ni mesečnih opravljenih delovnih ur',

    //Holiday plan
    HolidayPlan: 'Plan dopustov',
    AddPlan: 'Dodaj dopust',
    EditPlan: 'Uredi dopust',
    NoHolidayPlansFound: 'Plan dopustov je prazen',
    PlanConfirmed: 'Potrjen',

    //holiday
    Holiday: 'Praznik',
    Holidays: 'Prazniki',
    AddHoliday: 'Dodaj praznik',
    NoHolidayFound: 'Ni bilo najdenih praznikov',

    //user
    UsernameExsist: 'Uporabniško ime že obstaja',
    NoUsersFound: 'Ni bilo najdenih uporabnikov.',
    Users: 'Uporabniki',
    UsersList: 'Uporabniki',
    User: 'Uporabnik',
    EditUser: 'Uredi uporabnika',

    // people - person
    Person: 'Oseba',
    PersonData: 'Podatki osebe',
    Fullname: 'Ime in priimek',
    Firstname: 'Ime',
    Lastname: 'Priimek',

    // other
    Total: 'Skupno',
    NoData: 'Ni podatka',
    Date: 'Datum',
    DateFrom: 'Datum od',
    DateTo: 'Datum do',
    Weekday: 'Dan v tednu',
    Day: 'Dan',
    Add: 'Dodaj',
    Delete: 'Odstrani',
    Edit: 'Uredi',
    Cancel: 'Prekliči',
    Back: 'Nazaj',
    Update: 'Posodobi',
    Enable: 'Omogoči',
    Disable: 'Onemogoči',
    Confirm: 'Potrdi',
    Name: 'Ime',
    Send: 'Pošlji zahtevek',
    AddField: 'Dodaj polje',
    AddItem: 'Dodaj postavko',
    RemoveField: 'Odstrani polje',
    Next: 'Naprej',
    Remove: 'Odstrani',
    Actions: 'Dejanja',
    View: 'Ogled',
    Notes: 'Opombe',
    Items: 'Postavke',
    Download: 'Prenesi',
    Payment: 'Izplačilo',
    Filling: 'Polnitev',
    Login: 'Prijava',
    Logout: 'Odjava',
    Register: 'Registracija',
    ForgotPassword: 'Pozabljeno geslo',
    ResetPassword: 'Ponastavitev gesla',
    Profile: 'Profil',
    Search: 'Išči',

    // error
    Error: 'Napaka!',
    DataLoadingError: 'Prišlo je do napake pri nalaganju podatkov, prosim osvežite stran!',

    // success
    SuccessfullyAdded: 'Uspešno dodano!',
    SuccessfullyRemoved: 'Uspešno odstranjeno!',
    SuccessfullyUpdated: 'Uspešno posodbljeno!',

    UploadExcel: 'Naloži excel poročilo'
  },

  en: {
    //user
    UserList: 'Users',
    UserAdd: 'Add user',
    AddUser: 'Add user',
    Username: 'Username',
    Password: 'Password',
    RepeatPassword: 'Repeat password',
    BackToUsersButton: 'Back to users',
    UserSuccessfullyRemoved: 'User succesfully removed!',
    DeleteUserAlert: 'Are you sure to remove this user?',

    //report
    AddReport: 'Add report',
    ReportsList: 'Reports',
    Filename: 'Filename',
    Datetime: 'Date and time',
    Reports: 'Reports',
    ReportData: 'Report data',
    NoReportsFound: 'No reports were found.',
    AddDailyReport: 'Add daily report',
    DailyReport: 'Daily report',
    EditDailyReport: 'Edit daily report',
    DailyReportList: 'Daily report list',
    AddDailyCashierReport: 'Add daily cashier report',
    DailyCashierReport: 'Daily cashier report',
    EditDailyCashierReport: 'Edit daily cashier report',
    DailyCashierReportList: 'Daily cashier report list',
    AddWorkHourDiary: 'Add work hour diary',
    WorkHourDiary: 'Work hour diary',
    EditWorkHourDiary: 'Edit work hour diary',
    WorkHourDiaryList: 'Work hour diary list',
    AddAutomaticCashRegisterReport: 'Add automatic cash register report',
    AutomaticCashRegisterReport: 'Automatic cash register report',
    EditAutomaticCashRegisterReport: 'Edit automatic cash register report',
    AutomaticCashRegisterReportList: 'Automatic cash register report list',
    Report: 'Report',
    Cash: 'Cash',
    Pos: 'POS',
    TransferTRR: 'Transfer to TRR',
    Coins: 'Coins',
    CoinsTotal: 'Coins total',
    Banknotes: 'Banknotes',
    BanknotesTotal: 'Banknotes total',
    CoinsBanknotesTotal: 'Coins and banknotes total',
    Important: 'Important',
    GeneratePdf: 'Generate PDF',


    //shift
    Shift: 'Shift',
    Shifts: 'Shifts',
    AddShift: 'Add shift',
    ShiftAdd: 'Add shift',
    NoShiftsFound: 'No shofts found.',
    ShiftsList: 'Shifts',
    ShiftData: 'Shift data',
    EditShift: 'Edit shift',
    DeleteShiftAlert: 'Are you sure to remove this shift?',
    TimeFrom: 'Time from',
    TimeTo: 'Time to',
    AddWorkHours: 'Add work hours',
    WorkHours: 'Work hours',
    NoWorkHoursFound: 'No work hours found',
    ExtraHours: 'Extra hours',
    Explanation: 'Explanation',
    SearchWorkHours: 'Work hours in selected time frame',

    //Monthly working hours
    MonthlyWorkingHours: 'Monthly working hours',
    AddMonthlyWorkingHours: 'Add monthly working hours',
    EditMonthlyWorkingHours: 'Edit monthly working hours',
    NoMonthlyWorkingHoursFound: 'No monthly working hours found',

    //Holiday plan
    HolidayPlan: 'Holiday plan',
    AddPlan: 'Add holiday plan',
    EditPlan: 'Edit holiday plan',
    NoHolidayPlansFound: 'No holiday plans found',
    PlanConfirmed: 'Confirmed',

    //holiday
    Holiday: 'Holiday',
    Holidays: 'Holidays',
    AddHoliday: 'Add holiday',
    NoHolidayFound: 'No holidays found.',

    //user
    UsernameExsist: 'Username already exsist',
    NoUsersFound: 'No users found.',
    Users: 'Users',
    UsersList: 'Users',
    User: 'User',
    EditUser: 'Edit user',

    // people - person
    Person: 'Person',
    PersonData: 'Person data',
    Fullname: 'Firstname and lastname',
    Firstname: 'Firstname',
    Lastname: 'Lastname',

    // other
    Total: 'Total',
    NoData: 'No information',
    Date: 'Date',
    DateFrom: 'Date from',
    DateTo: 'Date to',
    Day: 'Day',
    Add: 'Add',
    Delete: 'Delete',
    Edit: 'Edit',
    Cancel: 'cancel',
    Back: 'Back',
    Update: 'Update',
    Enable: 'Enable',
    Disable: 'Disable',
    Confirm: 'Confirm',
    Name: 'Name',
    Send: 'Send',
    AddField: 'Add field',
    AddItem: 'Add item',
    RemoveField: 'Remove field',
    Next: 'Next',
    Remove: 'Remove',
    Actions: 'Actions',
    Notes: 'Notes',
    Download: 'Download',
    Payment: 'Payment',
    Filling: 'Filling',

    // error
    DataLoadingError: 'Error occured while loadin data. Please refresh the page.!',

    // success
    SuccessfullyAdded: 'Succesfully added!',
    SuccessfullyRemoved: 'Successfully removed!',
    SuccessfullyUpdated: 'Successfully updated!',

    UploadExcel: 'Upload excel report',

    Dashboard: 'Dashboard',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ItemDetails: 'Item Details',
    Items: 'Items',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Logout: 'Logout',
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    View: 'View',
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: 'Export Selected',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
  },
  de: {
    Dashboard: 'Instrumententafel',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Machen',
    Chat: 'Plaudern',
    Email: 'Email',
    Calendar: 'Kalender',
    FullCalendar: 'Calendrier completVollständiger Kalender',
    SimpleCalendar: 'Einfacher Kalender',
    Shop: 'Geschäft',
    ItemDetails: 'Artikeldetails',
    Cart: 'Wagen',
    WishList: 'Wunschzettel',
    Checkout: 'Auschecken',
    UI: 'UI',
    DataList: 'Datenliste',
    ListView: 'Listenansicht',
    ThumbView: 'Daumenansicht',
    Grid: 'Gitter',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Farben',
    Card: 'Karte',
    Basic: 'Basic',
    Statistics: 'Statistiken',
    Analytics: 'Analytics',
    CardActions: 'Kartenaktionen',
    CardColors: 'Kartenfarben',
    Table: 'Tabelle',
    agGridTable: 'agGrid-Tabelle',
    Components: 'Komponenten',
    Alert: 'Warnen',
    Avatar: 'Benutzerbild',
    Badge: 'Abzeichen',
    Breadcrumb: 'Breadcrumb',
    Button: 'Taste',
    ButtonGroup: 'Schaltflächengruppe',
    Chip: 'Chip',
    Collapse: 'Zusammenbruch',
    Dialogs: 'Dialoge',
    Divider: 'Teiler',
    DropDown: 'Dropdown-Liste',
    List: 'Liste',
    Loading: 'Wird geladen',
    Navbar: 'Navbar',
    Notifications: 'Benachrichtigungen',
    Pagination: 'Seitennummerierung',
    Popup: 'Pop-up',
    Progress: 'Fortschritt',
    Sidebar: 'Seitenleiste',
    Slider: 'Schieberegler',
    Tabs: 'Tabs',
    Tooltip: 'QuickInfo',
    Upload: 'Hochladen',
    FormsAndTable: 'Formulare und Tabelle',
    FormElements: 'Formularelemente',
    Select: 'Wählen',
    Switch: 'Schalter',
    Checkbox: 'Ankreuzfeld',
    Radio: 'Radio',
    Input: 'Eingang',
    NumberInput: 'Nummer eingeben',
    Textarea: 'Textbereich',
    FormLayouts: 'Formularlayouts',
    FormWizard: 'Formzauberer',
    FormValidation: 'Formularvalidierung',
    FormInputGroup: 'Formulareingabegruppe',
    Pages: 'Seiten',
    Authentication: 'Authentifizierung',
    Login: 'Anmeldung',
    Register: 'Registrieren',
    ForgotPassword: 'Passwort vergessen',
    ResetPassword: 'Passwort zurücksetzen',
    LockScreen: 'Bildschirm sperren',
    Miscellaneous: 'Verschiedenes',
    ComingSoon: 'Demnächst',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Nicht berechtigt',
    Maintenance: 'Instandhaltung',
    Profile: 'Profil',
    User: 'Benutzer',
    View: 'Aussicht',
    Edit: 'Bearbeiten',
    UserSettings: 'Benutzereinstellungen',
    Invoice: 'Rechnung',
    FAQ: 'FAQ',
    Search: 'Suche',
    KnowledgeBase: 'Wissensbasis',
    ChartsAndMaps: 'Diagramme und Karten',
    Charts: 'Diagramme',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Karte',
    Extensions: 'Erweiterungen',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Ziehen und loslassen',
    Datepicker: 'Datumsauswahl',
    DatetimePicker: 'Datum / Uhrzeit-Auswahl',
    AccessControl: 'Zugangskontrolle',
    I18n: 'I18n',
    Carousel: 'Karussell',
    Clipboard: 'Zwischenablage',
    ContextMenu: 'Kontextmenü',
    StarRatings: 'Sterne Bewertungen',
    Autocomplete: 'Autovervollständigung',
    Tree: 'Baum',
    // "Import/Export": 'Einführen/Export',
    Import: 'Einführen',
    Export: 'Export',
    ExportSelected: 'Auswahl exportieren',
    Others: 'Andere',
    MenuLevels: 'Menüebenen',
    MenuLevel2p1: 'Menüebene 2.1',
    MenuLevel2p2: 'Menüebene 2.2',
    MenuLevel3p1: 'Menüebene 3.1',
    MenuLevel3p2: 'Menüebene 3.2',
    DisabledMenu: 'Deaktiviertes Menü',
    Support: 'Unterstützung',
    Documentation: 'Dokumentation',
    RaiseSupport: 'Unterstützung erheben',
    demoTitle: 'Kartentitel',
    demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.'
  }
}
